import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const ImpersonationBanner = () => {
  const { isImpersonating, impersonatedProfile, originalProfile, stopImpersonation } = useAuth();
  const navigate = useNavigate();

  if (!isImpersonating || !impersonatedProfile || !originalProfile) {
    return null;
  }

  const handleStopImpersonation = async () => {
    const result = await stopImpersonation();
    if (result.success) {
      // Navigate back to admin dashboard
      navigate('/admin');
    }
  };

  const styles = {
    banner: {
      position: 'sticky',
      top: 0,
      zIndex: 9999,
      backgroundColor: '#ff6b35',
      color: 'white',
      padding: '12px 20px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      borderBottom: '3px solid #e55a2b',
      flexWrap: 'wrap',
      gap: '10px',
    },
    leftSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      flexWrap: 'wrap',
    },
    icon: {
      fontSize: '20px',
    },
    text: {
      fontSize: '14px',
      fontWeight: '500',
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
    },
    mainText: {
      fontSize: '16px',
      fontWeight: '700',
    },
    subText: {
      fontSize: '13px',
      opacity: 0.9,
    },
    badge: {
      display: 'inline-block',
      padding: '4px 8px',
      backgroundColor: 'rgba(255,255,255,0.2)',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: '600',
      textTransform: 'uppercase',
    },
    button: {
      padding: '10px 20px',
      backgroundColor: 'white',
      color: '#ff6b35',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontWeight: '600',
      fontSize: '14px',
      transition: 'all 0.2s',
      minHeight: '40px',
    },
  };

  return (
    <div style={styles.banner}>
      <div style={styles.leftSection}>
        <span style={styles.icon}>⚠️</span>
        <div style={styles.text}>
          <div style={styles.mainText}>
            Viewing as:{' '}
            <span style={styles.badge}>
              {impersonatedProfile.full_name || impersonatedProfile.email}
            </span>
          </div>
          <div style={styles.subText}>
            You are {originalProfile.full_name || originalProfile.email} (Super Admin)
          </div>
        </div>
      </div>
      <button
        style={styles.button}
        onClick={handleStopImpersonation}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#f0f0f0';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'white';
        }}
      >
        Exit Impersonation
      </button>
    </div>
  );
};

export default ImpersonationBanner;
